export function userDisplayName(user) {
  return user?.display_name ?? (user?.id ? `Пользователь #${user.id}` : '')
}
